import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { QuickActionCards } from '../components/QuickActionCards';
import { ServicesSection } from '../components/ServicesSection';
import { PortfolioPreview } from '../components/PortfolioPreview';
import { AboutSection } from '../components/AboutSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { ServiceAreasSection } from '../components/ServiceAreasSection';
import { CTABanner } from '../components/CTABanner';
import { Footer } from '../components/Footer';
export function HomePage() {
  useEffect(() => {
    document.title = 'BLC Custom Homes | Fresno General Contractor & Remodeling';
    // Set meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', 'BLC Custom Homes is a licensed general contractor in Fresno, CA, specializing in custom kitchens, bathrooms, and home remodeling with over 28 years of experience.');
  }, []);
  return <div className="min-h-screen flex flex-col font-sans relative" data-id="element-258">
      <Navigation data-id="element-259" />

      <main className="flex-grow relative z-0" data-id="element-260">
        <Hero data-id="element-261" />
        <TrustStrip data-id="element-262" />
        <QuickActionCards data-id="element-263" />
        <ServicesSection data-id="element-264" />
        <PortfolioPreview data-id="element-265" />
        <AboutSection data-id="element-266" />
        <ReviewsSection data-id="element-267" />
        <ServiceAreasSection data-id="element-268" />
        <CTABanner data-id="element-269" />
      </main>

      <Footer data-id="element-270" />
    </div>;
}